import { CheckCircleIcon, Icon } from 'smoothie';

export const SUCCESS_TOAST_MESSAGE = 'Saved!';
export const SUCCESS_TOAST_DURATION = 1500;

export const SuccessToastIcon = (
    <Icon icon={CheckCircleIcon} size={24} color="$green1000" />
);
